/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { clientControllerCreate } from '../fn/client/client-controller-create';
import { ClientControllerCreate$Params } from '../fn/client/client-controller-create';
import { clientControllerDelete } from '../fn/client/client-controller-delete';
import { ClientControllerDelete$Params } from '../fn/client/client-controller-delete';
import { clientControllerFindAll } from '../fn/client/client-controller-find-all';
import { ClientControllerFindAll$Params } from '../fn/client/client-controller-find-all';
import { clientControllerFindAllDropdown } from '../fn/client/client-controller-find-all-dropdown';
import { ClientControllerFindAllDropdown$Params } from '../fn/client/client-controller-find-all-dropdown';
import { clientControllerFindOne } from '../fn/client/client-controller-find-one';
import { ClientControllerFindOne$Params } from '../fn/client/client-controller-find-one';
import { clientControllerGenerateClientListExcel } from '../fn/client/client-controller-generate-client-list-excel';
import { ClientControllerGenerateClientListExcel$Params } from '../fn/client/client-controller-generate-client-list-excel';
import { clientControllerGetWord } from '../fn/client/client-controller-get-word';
import { ClientControllerGetWord$Params } from '../fn/client/client-controller-get-word';
import { clientControllerRestore } from '../fn/client/client-controller-restore';
import { ClientControllerRestore$Params } from '../fn/client/client-controller-restore';
import { clientControllerUpdate } from '../fn/client/client-controller-update';
import { ClientControllerUpdate$Params } from '../fn/client/client-controller-update';
import { ClientDto } from '../models/client-dto';
import { ClientListItemDto } from '../models/client-list-item-dto';
import { NameDto } from '../models/name-dto';
import { PaginatedDto } from '../models/paginated-dto';

@Injectable({ providedIn: 'root' })
export class ClientService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clientControllerFindAll()` */
  static readonly ClientControllerFindAllPath = '/api/client';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerFindAll$Response(params: ClientControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDto & {
'items'?: Array<ClientListItemDto>;
}>> {
    const obs = clientControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerFindAll(params: ClientControllerFindAll$Params, context?: HttpContext): Observable<PaginatedDto & {
'items'?: Array<ClientListItemDto>;
}> {
    const resp = this.clientControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PaginatedDto & {
'items'?: Array<ClientListItemDto>;
}>): PaginatedDto & {
'items'?: Array<ClientListItemDto>;
} => r.body)
    );
  }

  /** Path part for operation `clientControllerCreate()` */
  static readonly ClientControllerCreatePath = '/api/client';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientControllerCreate$Response(params: ClientControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientDto>> {
    const obs = clientControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientControllerCreate(params: ClientControllerCreate$Params, context?: HttpContext): Observable<ClientDto> {
    const resp = this.clientControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ClientDto>): ClientDto => r.body)
    );
  }

  /** Path part for operation `clientControllerUpdate()` */
  static readonly ClientControllerUpdatePath = '/api/client';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientControllerUpdate$Response(params: ClientControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientDto>> {
    const obs = clientControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientControllerUpdate(params: ClientControllerUpdate$Params, context?: HttpContext): Observable<ClientDto> {
    const resp = this.clientControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ClientDto>): ClientDto => r.body)
    );
  }

  /** Path part for operation `clientControllerFindAllDropdown()` */
  static readonly ClientControllerFindAllDropdownPath = '/api/client/dropdown';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientControllerFindAllDropdown()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerFindAllDropdown$Response(params: ClientControllerFindAllDropdown$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NameDto>>> {
    const obs = clientControllerFindAllDropdown(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientControllerFindAllDropdown$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerFindAllDropdown(params: ClientControllerFindAllDropdown$Params, context?: HttpContext): Observable<Array<NameDto>> {
    const resp = this.clientControllerFindAllDropdown$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<NameDto>>): Array<NameDto> => r.body)
    );
  }

  /** Path part for operation `clientControllerFindOne()` */
  static readonly ClientControllerFindOnePath = '/api/client/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerFindOne$Response(params: ClientControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientDto>> {
    const obs = clientControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerFindOne(params: ClientControllerFindOne$Params, context?: HttpContext): Observable<ClientDto> {
    const resp = this.clientControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ClientDto>): ClientDto => r.body)
    );
  }

  /** Path part for operation `clientControllerDelete()` */
  static readonly ClientControllerDeletePath = '/api/client/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerDelete$Response(params: ClientControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = clientControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerDelete(params: ClientControllerDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.clientControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `clientControllerGenerateClientListExcel()` */
  static readonly ClientControllerGenerateClientListExcelPath = '/api/client/excel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientControllerGenerateClientListExcel()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerGenerateClientListExcel$Response(params: ClientControllerGenerateClientListExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = clientControllerGenerateClientListExcel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientControllerGenerateClientListExcel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerGenerateClientListExcel(params: ClientControllerGenerateClientListExcel$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.clientControllerGenerateClientListExcel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `clientControllerGetWord()` */
  static readonly ClientControllerGetWordPath = '/api/client/word/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientControllerGetWord()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerGetWord$Response(params: ClientControllerGetWord$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = clientControllerGetWord(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientControllerGetWord$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerGetWord(params: ClientControllerGetWord$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.clientControllerGetWord$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `clientControllerRestore()` */
  static readonly ClientControllerRestorePath = '/api/client/restore/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientControllerRestore()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerRestore$Response(params: ClientControllerRestore$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = clientControllerRestore(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientControllerRestore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientControllerRestore(params: ClientControllerRestore$Params, context?: HttpContext): Observable<void> {
    const resp = this.clientControllerRestore$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
